export function SilalLandingAbout() {
  window.location.href = '/about.html';
  return <div>Directing to about...</div>;
}
